import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql-types'

const defaultOptions = {} as const
export type UpdateMessagePairThumbsMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  input: Types.OracleMessagePairUpdateInput;
}>;

export type UpdateMessagePairThumbsMutation = { __typename?: 'Mutation', oracleMessagePairUpdate: { __typename?: 'OracleMessagePairUpdateResponse', success: boolean, errors: Array<string>, oracleMessagePair?: { __typename?: 'OracleMessagePair', id: string, thumbsValue: string } | null } };

export type GetCurrentUserPostHogPropertiesQueryVariables = Types.Exact<{ [key: string]: never; }>;

export type GetCurrentUserPostHogPropertiesQuery = { __typename?: 'Query', userInfoCurrent?: { __typename?: 'UserInfoCurrentResponse', userInfo?: { __typename?: 'UserInfo', userTenureDays?: number | null, videosLast7Days?: number | null, daysWithViewershipLast7Days?: number | null, videoCompletionRate?: number | null, medianWatchTimePerWeek?: number | null, engagementCohort?: string | null, aiChatUsageFrequency?: number | null, aiGuideInteractionCount?: number | null } | null } | null };

export const UpdateMessagePairThumbsDocument = gql`
    mutation UpdateMessagePairThumbs($id: ID!, $input: OracleMessagePairUpdateInput!) {
  oracleMessagePairUpdate(id: $id, input: $input) {
    success
    errors
    oracleMessagePair {
      id
      thumbsValue
    }
  }
}
    `
export type UpdateMessagePairThumbsMutationFn = Apollo.MutationFunction<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>;

/**
 * __useUpdateMessagePairThumbsMutation__
 *
 * To run a mutation, you first call `useUpdateMessagePairThumbsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessagePairThumbsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessagePairThumbsMutation, { data, loading, error }] = useUpdateMessagePairThumbsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessagePairThumbsMutation (baseOptions?: Apollo.MutationHookOptions<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>(UpdateMessagePairThumbsDocument, options)
}
export type UpdateMessagePairThumbsMutationHookResult = ReturnType<typeof useUpdateMessagePairThumbsMutation>;
export type UpdateMessagePairThumbsMutationResult = Apollo.MutationResult<UpdateMessagePairThumbsMutation>;
export type UpdateMessagePairThumbsMutationOptions = Apollo.BaseMutationOptions<UpdateMessagePairThumbsMutation, UpdateMessagePairThumbsMutationVariables>;
export const GetCurrentUserPostHogPropertiesDocument = gql`
    query GetCurrentUserPostHogProperties {
  userInfoCurrent {
    userInfo {
      userTenureDays
      videosLast7Days
      daysWithViewershipLast7Days
      videoCompletionRate
      medianWatchTimePerWeek
      engagementCohort
      aiChatUsageFrequency
      aiGuideInteractionCount
    }
  }
}
    `

/**
 * __useGetCurrentUserPostHogPropertiesQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserPostHogPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserPostHogPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserPostHogPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserPostHogPropertiesQuery (baseOptions?: Apollo.QueryHookOptions<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>(GetCurrentUserPostHogPropertiesDocument, options)
}
export function useGetCurrentUserPostHogPropertiesLazyQuery (baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>(GetCurrentUserPostHogPropertiesDocument, options)
}
export function useGetCurrentUserPostHogPropertiesSuspenseQuery (baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>(GetCurrentUserPostHogPropertiesDocument, options)
}
export type GetCurrentUserPostHogPropertiesQueryHookResult = ReturnType<typeof useGetCurrentUserPostHogPropertiesQuery>;
export type GetCurrentUserPostHogPropertiesLazyQueryHookResult = ReturnType<typeof useGetCurrentUserPostHogPropertiesLazyQuery>;
export type GetCurrentUserPostHogPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserPostHogPropertiesSuspenseQuery>;
export type GetCurrentUserPostHogPropertiesQueryResult = Apollo.QueryResult<GetCurrentUserPostHogPropertiesQuery, GetCurrentUserPostHogPropertiesQueryVariables>;
